import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiGet, apiPost } from '../api/http';
import './ProjectEditor.css';

export default function ProjectEditor() {
  const navigate = useNavigate();
  const [layouts, setLayouts] = useState([]);
  const [loanTypes, setLoanTypes] = useState([]);
  const [selectedLayout, setSelectedLayout] = useState('');
  const [clientName, setClientName] = useState('');
  const [loanType, setLoanType] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const [layoutsData, loanTypesData] = await Promise.all([
          apiGet('/api/layouts'),
          apiGet('/api/loan-types'),
        ]);

        const safeLayouts = layoutsData || [];
        const safeLoanTypes = loanTypesData || [];

        setLayouts(safeLayouts);
        setLoanTypes(safeLoanTypes);

        if (safeLayouts.length > 0) {
          setSelectedLayout(String(safeLayouts[0].id));
        }
      } catch (err) {
        console.error('Failed to load dropdown data', err);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const handleSubmit = async (ev) => {
    ev.preventDefault();

    if (!clientName || !loanType || !selectedLayout) {
      alert('Please fill in all fields');
      return;
    }

    try {
      const res = await apiPost('/api/projects', {
        client_name: clientName,
        loan_type: loanType,
        layout_id: Number(selectedLayout),
      });

      // Client request: immediately land on Loan Eligibility Calculator after project creation.
      // Keep the project id available for other screens via query + localStorage.
      try {
        localStorage.setItem('lp.activeProjectId', String(res.id));
        // Also keep the client name so LoanEligibility can prefill Name field.
        localStorage.setItem('lp.activeProjectClientName', String(clientName || ''));
      } catch {
        // ignore
      }

      const safeName = encodeURIComponent(String(clientName || ''));
      navigate(`/loan-eligibility?projectId=${res.id}&clientName=${safeName}`);
    } catch (err) {
      alert('Failed to create project: ' + err.message);
    }
  };

  return (
    <div className="card project-editor">
      <h2>Create New Project</h2>

      {loading ? (
        <p>Loading form...</p>
      ) : (
        <form className="editor-form" onSubmit={handleSubmit}>
          <div className="form-field">
            <label htmlFor="clientName">Client Name</label>
            <input
              id="clientName"
              type="text"
              value={clientName}
              onChange={(e) => setClientName(e.target.value)}
              placeholder="Enter client name"
              required
            />
          </div>

          <div className="form-field">
            <label htmlFor="loanType">Loan Type</label>
            <select
              id="loanType"
              value={loanType}
              onChange={(e) => setLoanType(e.target.value)}
              required
            >
              <option value="">-- Select loan type --</option>
              {loanTypes.map((lt) => (
                <option key={lt.id} value={lt.name}>
                  {lt.name}
                </option>
              ))}
            </select>
          </div>
          <div className="form-actions">
            <button type="submit" className="btn primary">
              Create Project
            </button>
          </div>
        </form>
      )}
    </div>
  );
}
